
import { computed, defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'EmptyData',

  props: {
    height: {
      type: [Number, String],
      default: 400
    },
    bgColor: {
      type: String,
      // 作为 backgroundColor CSS 属性使用，用语义变量适配深色模式
      default: 'transparent'
    },
    text: {
      type: String,
      default: ''
    }
  },

  setup (props) {
    const { t } = useI18n()
    const style = computed(() => ({
      height: `${getHeight(props.height)}`,
      backgroundColor: props.bgColor
    }))

    function getHeight (value) {
      const tryNumber = +value
      if (typeof tryNumber === 'number' && tryNumber > 1 ) {
        return `${value}px`
      }
      return value
    }

    return {
      style,
      t
    }
  }
})
